export default __webpack_public_path__ + "static/media/register_assistant.2156d44a.png";